import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const clientSearchByName = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/clientsearchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const clientGetMyTransportVehicleInfoGroupOverview = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/clientgetmytransportvehicleinfogroupoverview' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getRootTransportVehicleInfoGroups = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/getroottransportvehicleinfogroups' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getChildrenGroups = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/getchildrentransportvehicleinfogroups/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDirectlyUnderBindAll = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/getdirectlyunderbindall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDirectlyUnderBindPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/getdirectlyunderbindpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientBindTransportVehicleInfoGroupsPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/getclientbindtransportvehicleinfogroupspage/' + params.userId + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const bindTransportVehicleInfoGroupsToUser = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/bindtransportvehicleinfogroupstouser/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindUserTransportVehicleInfoGroups = (params, urlParams) => {
  return axios.request({
    url: '/transport/transportvehicleinfogroup/unbindusertransportvehicleinfogroups/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

